:global(.MuiButton-root).link {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  display: flex;
  font-size: 14px;
  font-weight: 600;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  letter-spacing: 0;
  border-radius: 4px;
  text-transform: capitalize;
  white-space: nowrap;
}
.link {
  &.iconLeft {
    svg {
      margin-right: 6px;
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
  }
  &.iconRight {
    svg {
      margin-left: 6px;
      width: 18px;
      height: 18px;
      flex-shrink: 0;
    }
  }
}
.textLink {
  color: var(--pm-blue);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
.link.blue,
.link.blue path {
  color: var(--pm-blue);
  fill: var(--pm-blue);
}
:global(.dark) .link.blue path,
:global(.dark) .link.blue {
  fill: var(--pm-blue-lighter);
  color: var(--pm-blue-lighter);
}
.link.blue:after,
.link.blue:before {
  background-color: var(--pm-blue);
}
:global(.dark) .link.blue:after,
:global(.dark) .link.blue:before {
  background-color: var(--pm-blue-lighter);
}
.link.black,
.link.black path {
  color: var(--pm-black);
  fill: var(--pm-black);
}
:global(.dark) .link.black path,
:global(.dark) .link.black {
  fill: var(--pm-white);
  color: var(--pm-white);
}
.link.black:after,
.link.black:before {
  background-color: var(--pm-black);
}
:global(.dark) .link.black:after,
:global(.dark) .link.black:before {
  background-color: var(--pm-white);
}
.link.grey,
.link.grey path {
  color: var(--pm-grey5);
  fill: var(--pm-grey5);
  font-weight: 400;
}
:global(.dark) .link.grey path,
:global(.dark) .link.grey {
  fill: var(--pm-grey7);
  color: var(--pm-grey7);
}
.link.grey:after,
.link.grey:before {
  background-color: var(--pm-black);
}
:global(.dark) .link.grey:after,
:global(.dark) .link.grey:before {
  background-color: var(--pm-white);
}
.disabledLink {
  pointer-events: none;
}
.buttonLink {
  text-decoration: none;
  width: 100%;
}
:global(.dark) {
  .textLink {
    color: var(--pm-blue-lighter);
  }
}
